export default "__VITE_PUBLIC_ASSET__1a92f4d5__"